<template>
  <div>
    <div v-if="loading" class="flex justify-center py-10">
      <div
        class="h-10 w-10 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"
        role="status"
        aria-label="Chargement"
      />
    </div>

    <div v-if="error" class="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
      {{ error }}
    </div>

    <div
      v-if="!loading && !error"
      class="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    >
      <div
        v-for="card in statCards"
        :key="card.label"
        class="staff-stat-card"
        :class="card.toneClass"
      >
        <div class="mb-2 flex items-center justify-between gap-2">
          <div class="staff-stat-card__label">{{ card.label }}</div>
          <component :is="card.icon" class="staff-stat-card__icon h-5 w-5 shrink-0 opacity-80" aria-hidden="true" />
        </div>
        <div class="staff-stat-card__value">{{ card.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  ChatBubbleLeftRightIcon,
  UsersIcon,
  DocumentDuplicateIcon,
  CheckBadgeIcon,
  UserGroupIcon,
  AcademicCapIcon,
} from '@heroicons/vue/24/outline';
import { clearAuthenticatedSession, isAuthenticatedSession } from '@/utils/sessionAuth';

export default {
  name: 'StatsAdmin',
  data() {
    return {
      totalMessages: 0,
      totalClient: 0,
      formulairesEntames: 0,
      formulairesTermines: 0,
      totalEmploye: 0,
      totalUtilisateur: 0,
      loading: false,
      error: null,
    };
  },
  computed: {
    statCards() {
      return [
        {
          label: 'Messages envoyés',
          value: this.totalMessages,
          icon: ChatBubbleLeftRightIcon,
          toneClass: 'staff-stat-card--success',
        },
        {
          label: 'Total Client',
          value: this.totalClient,
          icon: UsersIcon,
          toneClass: 'staff-stat-card--gold',
        },
        {
          label: 'Formulaires entamés',
          value: this.formulairesEntames,
          icon: DocumentDuplicateIcon,
          toneClass: 'staff-stat-card--info',
        },
        {
          label: 'Formulaires terminés',
          value: this.formulairesTermines,
          icon: CheckBadgeIcon,
          toneClass: 'staff-stat-card--navy',
        },
        {
          label: 'Total Employé',
          value: this.totalEmploye,
          icon: UserGroupIcon,
          toneClass: 'staff-stat-card--brown',
        },
        {
          label: 'Total Utilisateur',
          value: this.totalUtilisateur,
          icon: AcademicCapIcon,
          toneClass: 'staff-stat-card--gold',
        },
      ];
    },
  },
  methods: {
    getValidToken() {
      try {
        return isAuthenticatedSession() ? '1' : null;
      } catch (_) {
        return null;
      }
    },
    async fetchStats() {
      this.loading = true;
      this.error = null;

      try {
        const token = this.getValidToken();
        if (!token) {
          this.error = 'Session invalide ou expirée. Veuillez vous reconnecter.';
          try {
            clearAuthenticatedSession();
          } catch (_) {}
          return;
        }
        const statsResponse = await axios.get('/api/admin/stats-dashboard/', { withCredentials: true });
        const statsData = statsResponse.data;

        this.totalMessages = statsData.total_messages || 0;
        this.totalClient = statsData.total_clients ?? statsData.total_client ?? 0;
        this.formulairesEntames = statsData.formulaires_entames || 0;
        this.formulairesTermines = statsData.formulaires_termines || 0;
        this.totalEmploye = statsData.total_employes ?? statsData.total_employe ?? 0;
        this.totalUtilisateur = statsData.total_utilisateurs ?? statsData.total_utilisateur ?? 0;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques admin:', error);
        this.error = 'Impossible de charger les statistiques.';
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchStats();
  },
};
</script>
